export const environment = {
  production: false,
  oktaWidgetConfig: {
    baseUrl: 'https://tmhccsurety.oktapreview.com',
    issuer: 'https://apiqa.artisanedge.com/1.0',
    redirectUri: 'https://qa.artisanedge.com/login/callback',
    clientId: 'not needed',
    scope: ['openid', 'email', 'profile']
  }
};
